// If already defined in common-critical file, skip it
!Hop.getModule('main-search_form', {silent: true}) &&
    Hop.defineModule('main-search_form', (root, param) => {
        const domInputs = root.querySelectorAll('input[type="text"]');
        const jobInput = root.querySelector('input[name="q"]');
        const locationInput = root.querySelector('input[name="location"]');

        function updateFieldState(input, opts) {
            if (input.getAttribute('type') !== 'hidden') {
                const domCurrentItem = input.closest('.main-search__item');
                if (opts.focus || opts.filled) {
                    domCurrentItem.classList.add('active');
                } else if (opts.blur && !opts.filled) {
                    domCurrentItem.classList.remove('active');
                }
            }
        }

        function onFocus(e) {
            updateFieldState(e.currentTarget, {
                focus: true,
            });
        }

        function onBlur(e) {
            const input = e.currentTarget;
            const value = input.value;
            updateFieldState(input, {
                blur: true,
                filled: value && value !== '',
            });
        }

        function onFocusJobInput() {
            Hop.gtm.push(param.gtmEventOnJobFieldFocus);
        }

        function onFocusLocationInput() {
            Hop.gtm.push(param.gtmEventOnLocationFieldFocus);
        }

        function onSubmit() {
            Hop.gtm.push(param.gtmEventOnSubmit);
        }

        function setUpHandlers() {
            if (!param.disableDomManipulation) {
                // This module is used in rebranded homepage and LP Categ
                // we don't want all these events because our components include their own Javascript logic
                domInputs.forEach((input) => {
                    input.addEventListener('focus', onFocus);
                    input.addEventListener('blur', onBlur);
                });
                window.addEventListener('load', onLoad, {once: true});
            }

            if (jobInput && param.gtmEventOnJobFieldFocus) {
                jobInput.addEventListener('focus', onFocusJobInput);
            }

            if (locationInput && param.gtmEventOnLocationFieldFocus) {
                locationInput.addEventListener('focus', onFocusLocationInput);
            }

            if (param.gtmEventOnSubmit) {
                root.addEventListener('submit', onSubmit);
            }
        }

        function onLoad() {
            domInputs.forEach((input) =>
                updateFieldState(input, {
                    filled: !!input.value,
                }),
            );
        }

        // Delegate click event to ensure searchbtnmobile is present
        const removeClickListener = Hop.delegate(document, 'click', '.js-search-home-btn', () => Hop.events.trigger('open-search'));

        setUpHandlers();

        return function destroy() {
            removeClickListener();

            if (!param.disableDomManipulation) {
                domInputs.forEach((input) => {
                    input.removeEventListener('focus', onFocus);
                    input.removeEventListener('blur', onBlur);
                });
            }

            if (jobInput) {
                jobInput.removeEventListener('focus', onFocusJobInput);
            }

            if (locationInput) {
                locationInput.removeEventListener('focus', onFocusLocationInput);
            }

            root.removeEventListener('submit', onSubmit);
        };
    });
